import { render } from "./EditPokokDoaView.vue?vue&type=template&id=7f18383a&ts=true"
import script from "./EditPokokDoaView.vue?vue&type=script&lang=ts"
export * from "./EditPokokDoaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__